"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.guidesReducer = exports.toggleHideGuidesPanel = exports.setGuidesGridWidth = exports.toggleGuidesVisible = exports.toggleGuidesExpanded = exports.toggleGuidesAvailable = exports.GuidesStateActionType = void 0;
const react_1 = require("react");
var GuidesStateActionType;
(function (GuidesStateActionType) {
    GuidesStateActionType["ToggleGuidesAvailable"] = "toggleGuidesAvailable";
    GuidesStateActionType["ToggleGuidesExpanded"] = "toggleGuidesExpanded";
    GuidesStateActionType["ToggleGuidesVisible"] = "toggleGuidesVisible";
    GuidesStateActionType["SetGuidesGridWidth"] = "setGuidesGridWidth";
    GuidesStateActionType["ToggleHideGuidesPanel"] = "toggleHideGuidesPanel";
})(GuidesStateActionType || (exports.GuidesStateActionType = GuidesStateActionType = {}));
const toggleGuidesAvailable = (isAvailable) => ({
    type: GuidesStateActionType.ToggleGuidesAvailable,
    payload: isAvailable,
});
exports.toggleGuidesAvailable = toggleGuidesAvailable;
const toggleGuidesExpanded = (isExpanded) => ({
    type: GuidesStateActionType.ToggleGuidesExpanded,
    payload: isExpanded,
});
exports.toggleGuidesExpanded = toggleGuidesExpanded;
const toggleGuidesVisible = (isVisible) => ({
    type: GuidesStateActionType.ToggleGuidesVisible,
    payload: isVisible,
});
exports.toggleGuidesVisible = toggleGuidesVisible;
const setGuidesGridWidth = (width) => ({
    type: GuidesStateActionType.SetGuidesGridWidth,
    payload: width,
});
exports.setGuidesGridWidth = setGuidesGridWidth;
const toggleHideGuidesPanel = (isHidden) => ({
    type: GuidesStateActionType.ToggleHideGuidesPanel,
    payload: isHidden,
});
exports.toggleHideGuidesPanel = toggleHideGuidesPanel;
function guidesReducer(state, action) {
    switch (action.type) {
        case GuidesStateActionType.ToggleGuidesExpanded:
            return Object.assign(Object.assign({}, state), { isGuidesExpanded: action.payload });
        case GuidesStateActionType.ToggleGuidesAvailable:
            return Object.assign(Object.assign({}, state), { isGuidesAvailable: action.payload });
        case GuidesStateActionType.ToggleGuidesVisible:
            return Object.assign(Object.assign({}, state), { isGuidesVisible: action.payload });
        case GuidesStateActionType.SetGuidesGridWidth:
            return Object.assign(Object.assign({}, state), { guidesGridWidth: action.payload });
        case GuidesStateActionType.ToggleHideGuidesPanel:
            console.log('Reducer: Updating isHideGuidesPanel to', action.payload);
            return Object.assign(Object.assign({}, state), { isHideGuidesPanel: action.payload });
        default:
            return state;
    }
}
exports.guidesReducer = guidesReducer;
function useGuidesReducer(state) {
    return (0, react_1.useReducer)(guidesReducer, state);
}
exports.default = useGuidesReducer;
